import { BaseListModel } from "../base/base-list-model";
import { CountryGroupModel } from "./country-group.model";

export const CountryGroupListModel = BaseListModel(CountryGroupModel).named("CountryGroups");
